export default "__VITE_ASSET__6ubI8G4P__"